import { Component, ViewChild, ElementRef } from '@angular/core';
import { NavController, NavParams, PopoverController, PopoverCmp, AlertController, ModalController, LoadingController, ToastController } from 'ionic-angular';
import { DIC } from '../dic';
import { GN } from '../../gn';
import { PopupPage } from '../popup/popup';
import * as moment from 'moment';
import { VehicleService } from '../../vehicles';

/**
 * Generated class for the DestinationPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-destination',
  templateUrl: 'destination.html',
})
export class DestinationPage {
  selectedVehiclesIds = [0]
  selectedVehiclesText = ''
  destination = '';
  tours = [];
  destTab: string = 'inserttour'
  multiclick = false

  constructor(public navCtrl: NavController, public navParams: NavParams, public dic: DIC, public popoverCtrl: PopoverController, public gn: GN, public alertCtrl: AlertController, public modalCtrl: ModalController, public loadingCtrl: LoadingController, public toastCtrl: ToastController, public vs: VehicleService) {
  }

  ionViewDidLoad() {
    if (this.gn.Vehicles[0] == undefined) {
      return false;
    }

    console.log('ionViewDidLoad DestinationPage');

    this.selectedVehiclesIds = [this.gn.Vehicles[0].vehicleid]
    this.selectedVehiclesText = this.gn.Vehicles[0].registration + ' (' + this.gn.Vehicles[0].code + ')'//this.dic.l["allvehicles"]

    this.loadData();
  }

  loadData() {
    var _that = this
    this.gn.Vehicles = []
    this.gn.VehiclesSortDt = []
    this.gn.VehiclesDic = []
    this.vs.loadInitVehicles(function () {
      _that.gn._Post('/api/gn/getdrivertoursmobile', { did: _that.gn.crypt(_that.gn.user.driverid) }, function (_data) {
        _that.tours = _data
        for (var i = 0; i < _that.tours.length; i++) {
          _that.tours[i].dt = moment(_that.tours[i].dt).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat)
          _that.tours[i].location1 = _that.tours[i].location.split('@')[0]
          if (_that.tours[i].location1 == '') {
            _that.tours[i].location1 = (_that.tours[i].location.split('@')[1]).split('editemployees')[1] + ', ' + _that.tours[i].location.split('@')[2]
          }
        }
      });
    })
  }
  Save() {
    this.multiclick = true

    if (this.destination == '') {
      const toast = this.toastCtrl.create({
        message: this.dic.l["enterdestination"],
        duration: 3000,
        position: 'top'
      });
      this.multiclick = false
      toast.present();
    } else {
      var _that = this
      this.gn._Post('/api/gn/setdrivervehiclemobile', { vid: _that.gn.crypt(this.selectedVehiclesIds), did: _that.gn.crypt(this.gn.user.driverid), destination: _that.gn.crypt(this.destination) }, function (_data2) {
        if (_data2.msg == 'Busy') {
          //var _mess = _data2.data[0].drivernamenew + ' ' + _that.dic.l["messpart1"] + ': ' + _data2.data[0].vehreg + ', ' + _that.dic.l["messpart2"] + ': ' + _data2.data[0].drivernamebusy + ' (' + moment(_data2.data[0].startdate).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat) + ')';
          var _mess = '@REQUEST@' + _that.gn.user.UserId + '@' + _that.gn.user.driverid + '@' + _data2.data[0].drivernamenew + '@' + _data2.data[0].driverid + '@' + _data2.data[0].drivernamebusy + '@' + _data2.data[0].vehicleid + '@' + _data2.data[0].vehreg + '@' + _that.gn.dic.Lang + '@' + _that.destination

          _that.gn._Post('/api/sendmesstoadmin', { fromuserid: _that.gn.crypt(_that.gn.user.UserId), cid: _that.gn.crypt(_that.gn.user.ClientId), mess: _that.gn.crypt(_mess) }, function (_data) {
            const toast = _that.toastCtrl.create({
              message: _that.dic.l["VehicleBusy"],
              duration: 3000,
              position: 'top'
            });
            toast.present();
          });
        } else {
          //var _mess = _data2.data[0].drivernamenew + ' ' + _that.dic.l["messpart1"] + ': ' + _data2.data[0].vehreg + ', ' + _that.dic.l["messpart2"] + ': ' + _data2.data[0].drivernamebusy + ' (' + moment(_data2.data[0].startdate).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat) + ')';
          var _mess = '@REQUEST@' + _that.gn.user.UserId + '@' + _that.gn.user.driverid + '@' + _data2.data[0].drivernamenew + '@-1@-1@' + _data2.data[0].vehicleid + '@' + _data2.data[0].vehreg + '@' + _that.gn.dic.Lang + '@' + _that.destination

          _that.gn._Post('/api/sendmesstoadmin', { fromuserid: _that.gn.crypt(_that.gn.user.UserId), cid: _that.gn.crypt(_that.gn.user.ClientId), mess: _that.gn.crypt(_mess) }, function (_data) {
            const toast = _that.toastCtrl.create({
              message: _that.dic.l["VehicleNotBusy"],
              duration: 3000,
              position: 'top'
            });
            toast.present();
          });
          // const toast = _that.toastCtrl.create({
          //   message: _that.dic.l["SaveTourDone"],
          //   duration: 3000,
          //   position: 'top'
          // });
          // toast.present();
          // for (var i = 0; i < _that.gn.Vehicles.length; i++) {
          //   if (_that.gn.Vehicles[i].vehicleid + '' == _that.selectedVehiclesIds + '') {
          //     _that.gn.Vehicles[i].driver = _data2.data[0].fullname
          //     _that.gn.Vehicles[i].driverdest = _data2.data[0].location
          //   }
          // }
          // setTimeout(() => {
          //   _that.gn._Post('/api/gn/getdrivertoursmobile', { did: _that.gn.crypt(_that.gn.user.driverid) }, function (_data) {
          //     _that.tours = _data
          //     for (var i = 0; i < _that.tours.length; i++) {
          //       _that.tours[i].dt = moment(_that.tours[i].dt).format(_that.gn.user.DFormat + ' ' + _that.gn.user.TFormat)
          //     }
          //     _that.destTab = 'mytours'
          //   });
          // }, 3100);
        }
        _that.multiclick = false
      })
    }
  }

  openVehiclePopup(_ev) {
    var oo = true;
    var _that = this
    var c = 1;
    let popover = this.popoverCtrl.create(PopupPage, {
      type: 'vehicles', onlyonevehicle: oo, selected: _that.selectedVehiclesIds, _if: c, callback: function (_text, _ids) {
        _that.selectedVehiclesIds = _ids
        _that.selectedVehiclesText = _text
      }
    });
    popover.present({
      ev: _ev
    });
  }


}



// WEBPACK FOOTER //
// ./src/pages/destination/destination.ts